import { EventEmitter } from "./eventemitter";
import { LogEvent } from "./interfaces";
import { LogData } from "./logger";

export class LegacyLogEmitter extends EventEmitter {
    private logEventName: string;
    private logQueue: LogEvent[] = [];

    constructor(logEventName: string, emitSynchronously?: boolean) {
        super(emitSynchronously);
        this.logEventName = logEventName;
    }

    public onLogEvent(logData: LogData) {
        // Convert the new LogData structure to legacy LogEvent for backward compatibility with 1.0 libraries.
        const logEvent: LogEvent = {
            logModule: "R",
            timeStamp: logData.timestamp,
            logLevel: logData.level,
            logtag: logData.tag,
            logstr: logData.message
        };
        if (this.hasListener(this.logEventName)) {
            this.emit(this.logEventName, logEvent);
        } else {
            this.logQueue.push(logEvent);
        }
    }

    public addListener(eventname: string, handler: Function) {
        super.addListener(eventname, handler);
        if (eventname == this.logEventName && this.logQueue.length > 0) {
            for (const logEvent of this.logQueue) {
                this.emit(this.logEventName, logEvent);
            }
            this.logQueue = [];
        }
    }
}
